<template>
  <v-layout align-center column>
    <p class="Section-Title">Keuntungan Pinjaman di Dompet Kilat</p>

    <div class="Proses-Mudah  justify-center">
      <v-skeleton-loader
        type="image"
        height="80"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pinjaman/Mudah.png"
        srcset="
          ../../assets/pinjaman/Mudah@2x.png 2x,
          ../../assets/pinjaman/Mudah@3x.png 3x
        "
        @load="onImgLoad"
        class="Mudah"
      />
      <p class="Title-Mudah">Proses Mudah</p>
      <p class="Desc">Proses pengajuan peminjaman cepat dan mudah.</p>
    </div>
    <div class="Bunga-Rendah">
      <v-skeleton-loader
        type="image"
        height="80"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pinjaman/Bunga.png"
        srcset="
          ../../assets/pinjaman/Bunga@2x.png 2x,
          ../../assets/pinjaman/Bunga@3x.png 3x
        "
        @load="onImgLoad"
        class="Bunga"
      />
      <p class="Title-Bunga">Bunga Kompetitif</p>
      <p class="Desc">
        Bunga pengembalian rendah mulai dari 1,25% per bulan.
      </p>
    </div>
    <div class="Transparant-Box">
      <v-skeleton-loader
        type="image"
        height="80"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pinjaman/Transparant.png"
        srcset="
          ../../assets/pinjaman/Transparant@2x.png 2x,
          ../../assets/pinjaman/Transparant@3x.png 3x
        "
        @load="onImgLoad"
        class="Transparant"
      />
      <p class="Title-Transparant">Transparant & Flexible</p>
      <p class="Desc">
        BPerjanjian transparan dengan tenor dan limit yang disesuaikan dengan
        kebutuhan.
      </p>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Mudah {
  /* max-width: 118px;
  max-height: 118px; */
  flex-grow: 0;
  margin: 0 88px 0px 78px;
  object-fit: contain;
}

.Bunga {
  /* width: 80px; */
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 102px 0px 78px;
  object-fit: contain;
}
.Transparant {
  /* width: 80px; */
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 102px 0px 78px;
  object-fit: contain;
}
.Proses-Mudah {
  width: 260px;
  /* height: 166px; */
  flex-grow: 0;
  margin: 10px 0 10px 0;
}
.Bunga-Rendah {
  width: 260px;
  /* height: 166px; */
  flex-grow: 0;
  margin: 10px 0 10px;
}
.Transparant-Box {
  width: 260px;
  /* height: 166px; */
  flex-grow: 0;
  margin: 10px 0 10px;
}
.Desc {
  width: 260px;
  height: 44px;
  flex-grow: 0;
  margin: 10px 0 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Mudah {
  width: 260px;
  height: 20px;
  flex-grow: 0;
  margin-left: 4px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Bunga {
  width: 260px;
  height: 20px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Transparant {
  width: 260px;
  height: 20px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Section-Title {
  width: 328px;
  height: 46px;
  flex-grow: 0;
  margin: 0px 2px 0px 3px;
  font-family: Sora;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
</style>
